import { httpApiMock } from '@app/api/mocks/http.api.mock';
import { AuthData } from '@app/api/auth.api';
import { initValues } from '@app/components/auth/LoginForm/LoginForm';

const avatarImg = process.env.REACT_APP_ASSETS_BUCKET + 'template.png';

httpApiMock.onPost('login').reply((config) => {
  const data: AuthData = JSON.parse(config.data || '');
  if (data.password === initValues.password) {
    return [
      200,
      {
        token: 'bearerToken',
        user: {
          id: 1,
          firstName: '유진',
          lastName: '임',
          imgUrl: avatarImg,
          userName: '@eugene',
          email: {
            name: 'seouli@gmail.com',
            verified: false,
          },
          phone: {
            number: '01025031234',
            verified: true,
          },
          sex: 'male',
          birthday: '01/26/2087',
          lang: 'kr',
          country: 'KO',
          city: 'Seoul',
          address1: 'Hangbokhan',
          zipcode: 52110,
          website: 'mbisq.com',
          socials: {
            twitter: '@eugene',
            facebook: 'https://facebook.com/groups/eugene',
          },
        },
      },
    ];
  } else return [401, { message: 'Invalid Credentials' }];
});

httpApiMock.onPost('signUp').reply(200);

httpApiMock.onPost('forgotPassword').reply(200);

httpApiMock.onPost('verifySecurityCode').reply(200);

httpApiMock.onPost('setNewPassword').reply(200);
